var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M31.883 17.058h-14.754v14.372h-2.37v-14.372h-14.677v-2.217h14.677v-14.448h2.37v14.448h14.754v2.217z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "closebtn",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.512 30.458l-12.519-12.519-12.195 12.195-2.011-2.011 12.195-12.195-12.454-12.454 1.881-1.881 12.454 12.454 12.26-12.26 2.011 2.011-12.26 12.26 12.519 12.519-1.881 1.881z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "analytics",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M31.333 30.667h-30.667c-0.368 0-0.667 0.299-0.667 0.667s0.299 0.667 0.667 0.667h30.667c0.368 0 0.667-0.299 0.667-0.667s-0.299-0.667-0.667-0.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M6 22.667h-4c-0.368 0-0.667 0.299-0.667 0.667v8c0 0.368 0.299 0.667 0.667 0.667h4c0.368 0 0.667-0.299 0.667-0.667v-8c0-0.368-0.299-0.667-0.667-0.667zM5.333 30.667h-2.667v-6.667h2.667v6.667h-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M14 16h-4c-0.368 0-0.667 0.299-0.667 0.667v14.667c0 0.368 0.299 0.667 0.667 0.667h4c0.368 0 0.667-0.299 0.667-0.667v-14.667c0-0.368-0.299-0.667-0.667-0.667zM13.333 30.667h-2.667v-13.333h2.667v13.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M22 18.667h-4c-0.368 0-0.667 0.299-0.667 0.667v12c0 0.368 0.299 0.667 0.667 0.667h4c0.368 0 0.667-0.299 0.667-0.667v-12c0-0.368-0.299-0.667-0.667-0.667zM21.333 30.667h-2.667v-10.667h2.667v10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M30 10.667h-4c-0.368 0-0.667 0.299-0.667 0.667v20c0 0.368 0.299 0.667 0.667 0.667h4c0.368 0 0.667-0.299 0.667-0.667v-20c0-0.368-0.299-0.667-0.667-0.667zM29.333 30.667h-2.667v-18.667h2.667v18.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M4 12c-1.471 0-2.667 1.196-2.667 2.667s1.196 2.667 2.667 2.667 2.667-1.196 2.667-2.667c0-1.471-1.196-2.667-2.667-2.667zM4 16c-0.736 0-1.333-0.599-1.333-1.333s0.597-1.333 1.333-1.333 1.333 0.599 1.333 1.333c0 0.735-0.597 1.333-1.333 1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M12 5.333c-1.471 0-2.667 1.196-2.667 2.667s1.196 2.667 2.667 2.667c1.471 0 2.667-1.196 2.667-2.667s-1.196-2.667-2.667-2.667zM12 9.333c-0.736 0-1.333-0.599-1.333-1.333s0.597-1.333 1.333-1.333 1.333 0.599 1.333 1.333c0 0.735-0.597 1.333-1.333 1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M20 8c-1.471 0-2.667 1.196-2.667 2.667s1.196 2.667 2.667 2.667c1.471 0 2.667-1.196 2.667-2.667s-1.196-2.667-2.667-2.667zM20 12c-0.736 0-1.333-0.599-1.333-1.333s0.597-1.333 1.333-1.333 1.333 0.599 1.333 1.333c0 0.735-0.597 1.333-1.333 1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M28 0c-1.471 0-2.667 1.196-2.667 2.667s1.196 2.667 2.667 2.667c1.471 0 2.667-1.196 2.667-2.667s-1.196-2.667-2.667-2.667zM28 4c-0.736 0-1.333-0.599-1.333-1.333s0.597-1.333 1.333-1.333 1.333 0.599 1.333 1.333c0 0.735-0.597 1.333-1.333 1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M27.059 3.608c-0.26-0.26-0.683-0.26-0.943 0l-5.173 5.173c-0.26 0.26-0.26 0.683 0 0.943 0.131 0.129 0.301 0.195 0.472 0.195 0.169 0 0.34-0.064 0.471-0.195l5.173-5.173c0.26-0.26 0.26-0.683 0-0.943z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M18.388 9.128l-4.283-1.221c-0.359-0.104-0.723 0.104-0.823 0.459-0.101 0.355 0.104 0.723 0.457 0.824l4.283 1.221c0.061 0.017 0.123 0.025 0.183 0.025 0.291 0 0.557-0.191 0.641-0.484 0.101-0.353-0.104-0.723-0.459-0.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M10.96 8.831c-0.229-0.288-0.648-0.335-0.936-0.107l-5.027 4.008c-0.288 0.231-0.336 0.649-0.105 0.937 0.132 0.165 0.327 0.251 0.521 0.251 0.145 0 0.292-0.048 0.415-0.144l5.027-4.008c0.288-0.231 0.336-0.649 0.105-0.937z"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrowback",
    viewBox: "0 0 124 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.586 14.586c-0.781 0.781-0.781 2.047 0 2.828l12.728 12.728c0.781 0.781 2.047 0.781 2.828 0s0.781-2.047 0-2.828l-11.314-11.314 11.314-11.314c0.781-0.781 0.781-2.047 0-2.828s-2.047-0.781-2.828 0l-12.728 12.728zM124 14h-120v4h120v-4z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "delete-white",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    style: {
      fill: "var(--color1, #ffffff)"
    },
    d: "M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.836 0 16-7.164 16-16s-7.164-16-16-16zM17.61 7.559h-3.209v0.54h-1.159v-0.616c0-0.597 0.486-1.083 1.083-1.083h3.361c0.597 0 1.083 0.486 1.083 1.083v0.616h-1.159v-0.54zM21.445 12.691c0.298 0 0.533 0.254 0.508 0.552l-0.909 11.246c-0.051 0.628-0.574 1.112-1.204 1.112h-7.67c-0.629 0-1.153-0.484-1.204-1.111l-0.91-11.246c-0.024-0.297 0.211-0.552 0.509-0.552h10.879zM13.2 24.4c0.319-0.020 0.562-0.295 0.543-0.614l-0.57-9.233c-0.020-0.32-0.296-0.562-0.614-0.543-0.319 0.020-0.562 0.295-0.543 0.614l0.57 9.233c0.019 0.307 0.274 0.544 0.578 0.544 0.012 0 0.024-0 0.036-0.001zM16.592 23.822v-9.233c0-0.32-0.26-0.579-0.58-0.579s-0.58 0.259-0.58 0.579v9.233c0 0.32 0.259 0.579 0.58 0.579s0.58-0.259 0.58-0.579zM19.995 14.623c0.019-0.319-0.225-0.594-0.544-0.613s-0.594 0.225-0.612 0.544l-0.544 9.233c-0.019 0.32 0.225 0.594 0.544 0.613l0.011 0 0.024 0c0.304 0 0.56-0.237 0.578-0.545l0.544-9.233zM23.069 9.762l0.381 1.141c0.073 0.22-0.022 0.444-0.2 0.556-0.072 0.046-0.159 0.073-0.253 0.073h-13.98c-0.094 0-0.18-0.027-0.253-0.073-0.178-0.112-0.274-0.336-0.2-0.556l0.381-1.141c0.1-0.301 0.382-0.504 0.699-0.504h12.728c0.317 0 0.599 0.203 0.699 0.504z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "delete",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    style: {
      fill: "var(--color2, #a6a6a6)"
    },
    d: "M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.836 0 16-7.164 16-16s-7.164-16-16-16zM17.61 7.559h-3.209v0.54h-1.159v-0.616c0-0.597 0.486-1.083 1.083-1.083h3.361c0.597 0 1.083 0.486 1.083 1.083v0.616h-1.159v-0.54zM21.445 12.691c0.298 0 0.533 0.254 0.508 0.552l-0.909 11.246c-0.051 0.628-0.574 1.112-1.204 1.112h-7.67c-0.629 0-1.153-0.484-1.204-1.111l-0.91-11.246c-0.024-0.297 0.211-0.552 0.509-0.552h10.879zM13.2 24.4c0.319-0.020 0.562-0.295 0.543-0.614l-0.57-9.233c-0.020-0.32-0.296-0.562-0.614-0.543-0.319 0.020-0.562 0.295-0.543 0.614l0.57 9.233c0.019 0.307 0.274 0.544 0.578 0.544 0.012 0 0.024-0 0.036-0.001zM16.592 23.822v-9.233c0-0.32-0.26-0.579-0.58-0.579s-0.58 0.259-0.58 0.579v9.233c0 0.32 0.259 0.579 0.58 0.579s0.58-0.259 0.58-0.579zM19.995 14.623c0.019-0.319-0.225-0.594-0.544-0.613s-0.594 0.225-0.612 0.544l-0.544 9.233c-0.019 0.32 0.225 0.594 0.544 0.613l0.011 0 0.024 0c0.304 0 0.56-0.237 0.578-0.545l0.544-9.233zM23.069 9.762l0.381 1.141c0.073 0.22-0.022 0.444-0.2 0.556-0.072 0.046-0.159 0.073-0.253 0.073h-13.98c-0.094 0-0.18-0.027-0.253-0.073-0.178-0.112-0.274-0.336-0.2-0.556l0.381-1.141c0.1-0.301 0.382-0.504 0.699-0.504h12.728c0.317 0 0.599 0.203 0.699 0.504z"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "triangleup",
    viewBox: "0 0 48 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0l20.785 30h-41.569l20.785-30z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "triangledown",
    viewBox: "0 0 48 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 32l20.785-30h-41.569l20.785 30z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "editbtn",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    style: {
      fill: "var(--color2, #a6a6a6)"
    },
    d: "M15.999 0c-8.836 0-15.999 7.164-15.999 16s7.163 16 15.999 16c8.836 0 16-7.164 16-16s-7.164-16-16-16zM23.605 11.514l-1.52 1.52-3.093-3.093-1.174 1.174 3.093 3.093-7.587 7.587-3.093-3.093-1.174 1.174 3.093 3.093-0.756 0.756-0.014-0.014c-0.084 0.138-0.22 0.239-0.382 0.275l-2.885 0.643c-0.043 0.010-0.087 0.014-0.131 0.014-0.157 0-0.31-0.062-0.424-0.176-0.146-0.145-0.206-0.354-0.161-0.555l0.643-2.884c0.036-0.162 0.137-0.298 0.275-0.382l-0.015-0.015 12.21-12.211c0.179-0.179 0.47-0.179 0.649 0.001l2.445 2.444c0.179 0.179 0.179 0.47-0 0.649z"
  })), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "addpeople",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.529 21.037c-0.782-0.546-1.619-0.991-2.493-1.331 1.163-1.057 1.935-2.539 2.069-4.197 1.764-1.719 4.077-2.661 6.556-2.661 1.935 0 3.794 0.583 5.374 1.685 0.566 0.395 1.345 0.256 1.74-0.31s0.256-1.345-0.31-1.74c-0.783-0.546-1.619-0.99-2.493-1.331 1.284-1.167 2.091-2.849 2.091-4.716 0-3.515-2.86-6.374-6.374-6.374s-6.374 2.859-6.374 6.374c0 1.86 0.8 3.536 2.075 4.702-0.175 0.067-0.348 0.138-0.52 0.214-0.782 0.344-1.518 0.768-2.201 1.265-0.943-2.343-3.239-4.001-5.916-4.001-3.515 0-6.374 2.859-6.374 6.374 0 1.855 0.796 3.526 2.064 4.692-3.39 1.27-6.139 3.999-7.259 7.478-0.371 1.154-0.175 2.377 0.539 3.357s1.818 1.541 3.030 1.541h10.874c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25h-10.874c-0.404 0-0.772-0.187-1.010-0.514s-0.303-0.735-0.18-1.119c1.235-3.841 5.003-6.523 9.162-6.523 1.935 0 3.793 0.583 5.374 1.685 0.566 0.395 1.345 0.256 1.74-0.31s0.256-1.345-0.31-1.74zM24.688 2.562c2.136 0 3.875 1.738 3.875 3.874s-1.738 3.874-3.875 3.874c-2.136 0-3.874-1.738-3.874-3.874s1.738-3.874 3.874-3.874zM11.752 11.116c2.136 0 3.874 1.738 3.874 3.874s-1.738 3.875-3.874 3.875-3.874-1.738-3.874-3.875c0-2.136 1.738-3.874 3.874-3.874zM32 26.122c0 0.69-0.56 1.25-1.25 1.25h-3.437v3.437c0 0.69-0.56 1.25-1.25 1.25s-1.25-0.56-1.25-1.25v-3.437h-3.437c-0.69 0-1.25-0.56-1.25-1.25s0.56-1.25 1.25-1.25h3.437v-3.437c0-0.69 0.56-1.25 1.25-1.25s1.25 0.56 1.25 1.25v3.437h3.437c0.691 0 1.25 0.56 1.25 1.25z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "findbtn",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    style: {
      fill: "var(--color2, #a6a6a6)"
    },
    d: "M31.609 29.724l-9.1-9.1c1.763-2.177 2.824-4.944 2.824-7.957 0-6.984-5.683-12.667-12.667-12.667s-12.666 5.683-12.666 12.666c0 6.984 5.683 12.667 12.667 12.667 3.013 0 5.78-1.061 7.957-2.824l9.1 9.1c0.26 0.26 0.601 0.391 0.943 0.391s0.683-0.131 0.943-0.391c0.521-0.521 0.521-1.364-0-1.885zM12.667 22.667c-5.515 0-10-4.485-10-10s4.485-10 10-10c5.515 0 10 4.485 10 10s-4.485 10-10 10z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "leftpointer",
    viewBox: "0 0 23 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M20.571 29.714l-18.286-13.714 18.286-13.714"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "rightpointer",
    viewBox: "0 0 23 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M2.286 29.714l18.286-13.714-18.286-13.714"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "logoutSecondary",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f2f7",
    style: {
      fill: "var(--color1, #f1f2f7)",
      stroke: "var(--color1, #f1f2f7)"
    },
    stroke: "#f1f2f7",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 0.5333,
    d: "M26.769 11.242v-0c0.384-0.384 1.007-0.384 1.391 0l2.799 2.799c1.115 1.114 1.115 2.928 0 4.042l-2.799 2.799c-0.192 0.192-0.443 0.288-0.695 0.288s-0.503-0.096-0.695-0.288v0c-0.384-0.384-0.384-1.006 0-1.39v0l2.446-2.446h-15.653c-0.543 0-0.983-0.44-0.983-0.983s0.44-0.983 0.983-0.983h15.653l-2.446-2.447c-0.384-0.384-0.384-1.006 0-1.39zM22.358 24.5v2.5c0 2.61-2.124 4.733-4.733 4.733h-12.563c-2.61 0-4.733-2.124-4.733-4.733v-22c0-2.61 2.124-4.733 4.733-4.733h12.563c2.61 0 4.733 2.124 4.733 4.733v2.5c0 0.543-0.44 0.983-0.983 0.983s-0.983-0.44-0.983-0.983v-2.5c0-1.526-1.241-2.767-2.767-2.767h-12.563c-1.526 0-2.767 1.241-2.767 2.767v22c0 1.526 1.241 2.767 2.767 2.767h12.563c1.526 0 2.767-1.241 2.767-2.767v-2.5c0-0.543 0.44-0.983 0.983-0.983s0.983 0.44 0.983 0.983z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logoutPrimary",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(24, 28, 39, 0.6)",
    style: {
      fill: "var(--color2, rgba(24, 28, 39, 0.6))"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 0.5333,
    d: "M26.769 11.242v-0c0.384-0.384 1.007-0.384 1.391 0l2.799 2.799c1.115 1.114 1.115 2.928 0 4.042l-2.799 2.799c-0.192 0.192-0.443 0.288-0.695 0.288s-0.503-0.096-0.695-0.288v0c-0.384-0.384-0.384-1.006 0-1.39v0l2.446-2.446h-15.653c-0.543 0-0.983-0.44-0.983-0.983s0.44-0.983 0.983-0.983h15.653l-2.446-2.447c-0.384-0.384-0.384-1.006 0-1.39zM22.358 24.5v2.5c0 2.61-2.124 4.733-4.733 4.733h-12.563c-2.61 0-4.733-2.124-4.733-4.733v-22c0-2.61 2.124-4.733 4.733-4.733h12.563c2.61 0 4.733 2.124 4.733 4.733v2.5c0 0.543-0.44 0.983-0.983 0.983s-0.983-0.44-0.983-0.983v-2.5c0-1.526-1.241-2.767-2.767-2.767h-12.563c-1.526 0-2.767 1.241-2.767 2.767v22c0 1.526 1.241 2.767 2.767 2.767h12.563c1.526 0 2.767-1.241 2.767-2.767v-2.5c0-0.543 0.44-0.983 0.983-0.983s0.983 0.44 0.983 0.983z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.1b2fd616b0ea019d2e0e884eca8b521a.svg";
export { ForwardRef as ReactComponent };